module.exports = __webpack_public_path__ + "11a0477b1cbf8e608265fbd818f77d79.svg";